import { createNextTableContext } from '@core/table';

export const StatusTableContext = createNextTableContext();
